import instance from "../api/instance";
import sessionService from "../services/sessionService";

import {
  SET_PAGE,
  RESET_APP,
  SET_COUNTRY,
  SAVE_SESSION,
  RENEW_SESSION,
  DELETE_SESSION,
  SAVE_SESSION_DUMMY,
  SAVE_SESSION_REGISTER,
} from "../constants/constants";
import { customDecode } from "../../components/utils/functions";

export const login = (userdata) => {
  return (dispatch) => {
    return instance
      .post(`/api/login`, userdata)
      .then((response) => {
        sessionService.saveSession(response.data.data);
        var jsonDecoded = customDecode(response.data.data.jwt);

        var userRoles = getRoles(jsonDecoded.authorities);
        dispatch({
          type: SAVE_SESSION,
          payload: {
            session: response.data.data,
            countryCode: jsonDecoded.COUNTRYCODE,
            userType: jsonDecoded.user_type,
            username: response.data.data.code,
            roles: userRoles,
            clientId: jsonDecoded?.customer_id,
          },
        });
        return response;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const register = (userdata, country) => {
  return (dispatch) => {
    return instance
      .post(`/register`, userdata, { headers: { "x-country-code": country } })
      .then((response) => {
        sessionService.saveSession(response.data.data);
        dispatch({
          type: SAVE_SESSION_REGISTER,
          payload: {
            register: response.data.data,
            userData: userdata,
          },
        });
        return response;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const validateUser = (userdata) => {
  return (dispatch) => {
    return instance
      .post(`/validate-user`, userdata)
      .then((response) => {
        sessionService.saveSession(response.data.data);
        dispatch({
          type: SAVE_SESSION_DUMMY,
          payload: {
            validateUser: response.data.data,
          },
        });
        return response;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const logout = () => {
  // clear session data;
  return (dispatch, getState) => {
    const payload = getState().envReducer?.environment === "prd";
    return instance
      .post("/logout")
      .then(() => {
        sessionService.logout();
        dispatch({ type: DELETE_SESSION, payload });
        dispatch({ type: RESET_APP });
      })
      .catch((err) => {
        sessionService.logout();
        dispatch({ type: DELETE_SESSION, payload });
        dispatch({ type: RESET_APP });
        return Promise.reject(err);
      });
  };
};

export const refreshToken = () => {
  return (dispatch) => {
    return instance
      .get("/refresh-token")
      .then((response) => {
        return dispatch({ type: RENEW_SESSION, payload: response.data.data });
      })
      .catch(() => dispatch(logout()));
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, page: page });
  };
};

export const selectCountry = (country) => {
  return (dispatch) => {
    dispatch({ type: SET_COUNTRY, country: country });
    sessionService.setUser({ countryCode: country });
  };
};

const getRoles = (authorities) => {
  var roles = {};

  authorities.map((item) => {
    var permissions = item.split(":");

    if (roles[permissions[1]] == undefined) {
      roles[permissions[1]] = { actions: [] };
    }

    var actions = roles[permissions[1]].actions;
    actions.push(permissions[0]);
  });

  return roles;
};
